{
  "$id": "pentest-progress",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "schema_version",
    "generated_by",
    "framework_version",
    "run_id",
    "workflow",
    "status",
    "started_at",
    "updated_at",
    "report_path",
    "sidecar_path",
    "target_url",
    "source_report_path",
    "steps",
    "skill_invocations",
    "script_artifacts",
    "current_finding_ids"
  ],
  "properties": {
    "schema_version": { "const": "1" },
    "generated_by": { "const": "paqad-ai" },
    "framework_version": { "type": "string", "minLength": 1 },
    "run_id": { "type": "string", "minLength": 1 },
    "workflow": { "type": "string", "enum": ["pentest", "pentest-retest"] },
    "status": { "type": "string", "enum": ["running", "completed", "blocked", "failed"] },
    "started_at": { "type": "string", "format": "date-time" },
    "updated_at": { "type": "string", "format": "date-time" },
    "report_path": { "type": ["string", "null"] },
    "sidecar_path": { "type": ["string", "null"] },
    "target_url": { "type": ["string", "null"] },
    "source_report_path": { "type": ["string", "null"] },
    "steps": {
      "type": "array",
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "id",
          "title",
          "status",
          "input_hash",
          "artifact_paths",
          "skill_names",
          "error",
          "started_at",
          "completed_at"
        ],
        "properties": {
          "id": { "type": "string", "minLength": 1 },
          "title": { "type": "string", "minLength": 1 },
          "status": {
            "type": "string",
            "enum": ["not_started", "running", "completed", "blocked", "failed"]
          },
          "input_hash": { "type": ["string", "null"] },
          "artifact_paths": { "type": "array", "items": { "type": "string" } },
          "skill_names": { "type": "array", "items": { "type": "string" } },
          "error": { "type": ["string", "null"] },
          "started_at": { "type": ["string", "null"], "format": "date-time" },
          "completed_at": { "type": ["string", "null"], "format": "date-time" }
        }
      }
    },
    "skill_invocations": { "type": "array", "items": { "type": "string" } },
    "script_artifacts": { "type": "array", "items": { "type": "string" } },
    "current_finding_ids": { "type": "array", "items": { "type": "string" } },
    "incremental_type": { "type": "string", "enum": ["full", "incremental"] },
    "git_commit": { "type": "string" },
    "file_hashes": { "type": "object", "additionalProperties": { "type": "string" } }
  }
}
